import { type DistributionRestriction, RestrictionType } from "../../gql-generated/types";

export interface DistributionRestrictionsResult {
    distributionRestrictionsRaw: readonly DistributionRestriction[];
    types: Set<RestrictionType>;
    messagesDeduped: readonly string[];
    hasProfileDistributionRestrictions: boolean;
    hasLensLevelDistributionRestrictions: boolean;
}

export const makeDistributionRestrictionsResult = (
    distributionRestrictions: readonly DistributionRestriction[],
): DistributionRestrictionsResult => {
    const types = new Set(distributionRestrictions.map((restriction) => restriction.restrictionType));
    const messagesDeduped = new Set(distributionRestrictions.flatMap((restriction) => restriction.messagesList));

    return {
        distributionRestrictionsRaw: distributionRestrictions,
        types,
        messagesDeduped: [...messagesDeduped],
        hasProfileDistributionRestrictions: types.has(RestrictionType.RestrictionTypeAppSurface),
        hasLensLevelDistributionRestrictions:
            types.has(RestrictionType.RestrictionTypeAge) || types.has(RestrictionType.RestrictionTypeCountry),
    };
};
